import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { reloadOnceForChunkError } from "./lib/chunk-recovery";

// Auto-recover from stale chunk errors after a preview refresh/deploy.
function handleChunkLoadError(event: Event) {
  const msg =
    (event as ErrorEvent).message ||
    ((event as ErrorEvent).error && String((event as ErrorEvent).error)) ||
    ((event as PromiseRejectionEvent).reason &&
      ((event as PromiseRejectionEvent).reason.message ||
        String((event as PromiseRejectionEvent).reason))) ||
    "";

  reloadOnceForChunkError(msg);
}
window.addEventListener("error", handleChunkLoadError);
window.addEventListener("unhandledrejection", handleChunkLoadError);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
